import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { Helmet } from "react-helmet";
import { authFetch } from "../utils/authFetch";
import { hasPerm } from "../utils/permission";

const toast = (msg, type = "success") => {
  toastr.options = { closeButton: true, progressBar: true, timeOut: "3000" };
  toastr[type](msg);
};

function Verify_token() {

  const emptyForm = {
    product_type: "",
    ip: "",
    domain: "",
    callbackurl: "",
    redirecturl: ""
  };

  const [form, setForm] = useState(emptyForm);
  const [tokens, setTokens] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const roleId = currentUser.role_id;

  /* ───────── Fetch Tokens ───────── */
  const fetchTokens = async () => {
    try {

      const res = await authFetch("/api/v1/verification_token/list");
      if (!res) return;

      const data = await res.json();

      const normalized = (Array.isArray(data) ? data : []).map((t) => ({
        ...t,
        id: t.id || t._id
      }));

      setTokens(normalized);

    } catch {
      toast("Failed to fetch tokens", "error");
    }
  };

  const fetchProducts = async () => {
    try {

        const res = await authFetch("/api/v1/product_services/list");
        if (!res) return;

        const data = await res.json();

        setProducts(Array.isArray(data) ? data : []);

    } catch {
        toast("Failed to fetch products", "error");
    }
  };

  useEffect(() => {
    fetchTokens();
    fetchProducts();
  }, []);

  /* ───────── Save Token (Create / Update) ───────── */
  const saveToken = async () => {

    if (!form.product_type || !form.ip || !form.domain) {
      return toast("Product Type, IP & Domain are required", "error");
    }

    setLoading(true);

    const url = editingId
      ? `/api/v1/verification_token/update/${editingId}`
      : `/api/v1/verification_token/create`;

    const method = editingId ? "PUT" : "POST";

    try {

      const res = await authFetch(url, {
        method,
        body: JSON.stringify(form)
      });

      const json = await res.json();

      if (!res.ok) throw new Error(json.detail || "Request failed");

      toast(editingId ? "Token updated successfully" : "Token created successfully");

      setForm(emptyForm);
      setEditingId(null);

      fetchTokens();

      document.querySelector("#tokenModal .btn-close")?.click();

    } catch (err) {
      toast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  /* ───────── Update Callback ───────── */
  const updateCallback = async () => {

    if (!form.callbackurl) {
      return toast("Callback URL required", "error");
    }

    try {

      const res = await authFetch("/api/v1/verification_token/callback", {
        method: "PUT",
        body: JSON.stringify({ callbackurl: form.callbackurl })
      });

      const json = await res.json();

      if (!res.ok) throw new Error(json.detail);

      toast("Callback Updated");

      fetchTokens();

    } catch (err) {
      toast(err.message, "error");
    }
  };

  /* ───────── Edit Token ───────── */
  const handleEdit = (t) => {

    setForm({
      product_type: t.product_type || "",
      ip: t.ip || "",
      domain: t.domain || "",
      callbackurl: t.callbackurl || "",
      redirecturl: t.redirecturl || ""
    });

    setEditingId(t.id);
  };

  /* ───────── Delete Token ───────── */
  const handleDelete = async (id) => {

    if (!window.confirm("Delete this token?")) return;

    try {

      const res = await authFetch(`/api/v1/verification_token/delete/${id}`, {
        method: "DELETE"
      });

      const json = await res.json();

      if (!res.ok) throw new Error(json.detail || "Delete failed");

      toast("Token deleted");

      fetchTokens();

    } catch (err) {
      toast(err.message, "error");
    }
  };

  /* ───────── Input Change ───────── */
  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ───────── Render ───────── */

  return (
    <>
      <Helmet>
        <title>Verification API Token | Suvidha</title>
      </Helmet>

      <div className="page-wrapper">
        <div className="page-content-wrapper">
          <div className="page-content">

            <div className="card">
              <div className="card-body">

                <div className="card-title d-flex justify-content-between">

                  <h4>Verification Token Manager</h4>

                  {hasPerm("verify_token_add") && roleId !== "1" && (

                    <button
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#tokenModal"
                      onClick={() => {
                        setForm(emptyForm);
                        setEditingId(null);
                      }}
                    >
                      Add 
                    </button>

                  )}

                </div>

                {/* Modal */}

                <div className="modal fade" id="tokenModal">

                  <div className="modal-dialog">
                    <div className="modal-content">

                      <div className="modal-header">

                        <h5>
                          {editingId ? "Edit Token" : "Add Token"}
                        </h5>

                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        />

                      </div>

                      <div className="modal-body">

                        <label className="form-label">Product Type</label>

                        {/* <select
                          className="form-control mb-2"
                          name="product_type"
                          value={form.product_type}
                          onChange={onChange}
                        >
                          <option value="">Select Product</option>
                          <option value="pan">PAN</option>
                          <option value="aadhaar">AADHAAR</option>
                          <option value="gst">GST</option>
                        </select> */}

                        <select
                            className="form-control mb-2"
                            name="product_type"
                            value={form.product_type}
                            onChange={onChange}
                            >
                            <option value="">Select Product</option>

                            {products.map((p) => (
                                <option key={p.id || p._id} value={p.name} style={{ textTransform: "uppercase" }}>
                                {p.name}
                                </option>
                            ))}

                        </select>

                        {["ip", "domain", "callbackurl", "redirecturl"].map((f) => (

                          <div key={f}>

                            <label className="form-label text-capitalize">{f}</label>

                            <input
                              className="form-control mb-2"
                              name={f}
                              value={form[f]}
                              onChange={onChange}
                            />

                          </div>

                        ))}

                      </div>

                      <div className="modal-footer">

                        <button
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>

                        <button
                          className="btn btn-primary"
                          onClick={saveToken}
                          disabled={loading}
                        >
                          {loading ? "Saving..." : editingId ? "Update" : "Save"}
                        </button>

                      </div>

                    </div>
                  </div>

                </div>

                {/* Table */}

                <hr />

                <div className="table-responsive">

                  <table className="table table-bordered">

                    <thead>

                      <tr>
                        {roleId == "1" && (
                        <th>Product</th>
                        )}
                        <th>IP</th>
                        <th>Token</th>
                        {roleId == "1" && (
                          <th>Name</th>
                        )}
                        <th>Domain</th>
                        <th>Callback</th>
                        <th>Redirect</th>

                        {hasPerm("verify_token_edit") && roleId !== "1" && (
                          <th>Actions</th>
                        )}

                      </tr>

                    </thead>

                    <tbody>

                      {tokens.length === 0 && (

                        <tr>
                          <td colSpan="8" className="text-center">
                            No Tokens found
                          </td>
                        </tr>

                      )}

                      {tokens.map((t) => (

                        <tr key={t.id}>
                          {roleId == "1" && (  
                          <td>{t.product_type}</td>
                          )}
                          <td>{t.ip}</td>
                          <td>{t.token}</td>
                          {roleId == "1" && (
                          <td>{t.user_name}</td>
                          )}
                          <td>{t.domain}</td>
                          <td>{t.callbackurl}</td>
                          <td>{t.redirecturl}</td>

                          {hasPerm("verify_token_edit") && roleId !== "1" && (

                            <td>

                              <button
                                className="btn btn-info btn-sm me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#tokenModal"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>

                              {/* <button
                                className="btn btn-danger btn-sm d-none"
                                onClick={() => handleDelete(t.id)}
                              >
                                Delete
                              </button> */}

                            </td>

                          )}

                        </tr>

                      ))}

                    </tbody>

                  </table>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </>
  );
}

export default Verify_token;